import { useState } from 'react';
import api from '../lib/api';
import { Sparkles, Lightbulb, Heart, ShieldCheck } from 'lucide-react';

const REACTIONS = [
  { key: 'acknowledged', label: 'Acknowledged', icon: Sparkles, color: '#D4AF37' },
  { key: 'reframed', label: 'Reframed', icon: Lightbulb, color: '#8B5CF6' },
  { key: 'felt_seen', label: 'Felt seen', icon: Heart, color: '#EC4899' },
  { key: 'felt_safer', label: 'Felt safer', icon: ShieldCheck, color: '#10B981' },
];

const ReactionChips = ({ messageId, initialReaction = null }) => {
  const [selected, setSelected] = useState(initialReaction);
  const [pending, setPending] = useState(false);

  const handleClick = async (key) => {
    if (pending || !messageId) return;
    const next = selected === key ? '' : key;
    const prev = selected;
    setSelected(next || null);
    setPending(true);
    try {
      await api.post('/reaction/log', { message_id: messageId, reaction: next });
    } catch {
      setSelected(prev); // revert on failure
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="pt-4 border-t border-[#27272A]" data-testid={`reaction-chips-${messageId}`}>
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#A1A1AA] mb-3">
        What helped you here?
      </p>
      <div className="flex flex-wrap gap-2">
        {REACTIONS.map((r) => {
          const Icon = r.icon;
          const active = selected === r.key;
          return (
            <button
              key={r.key}
              type="button"
              onClick={() => handleClick(r.key)}
              disabled={pending}
              data-testid={`reaction-${r.key}-${messageId}`}
              data-active={active ? 'true' : 'false'}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${
                active
                  ? 'border-transparent text-[#0A0A0A]'
                  : 'border-[#27272A] text-[#A1A1AA] hover:border-[#8B5CF6] hover:text-[#F9FAFB] bg-[#0A0A0A]'
              }`}
              style={active ? { backgroundColor: r.color } : undefined}
            >
              <Icon className="w-3.5 h-3.5" />
              {r.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReactionChips;
